import { Box, Modal } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
// import EditKPITable from "./EditKPITable";
import KpiTemplateModalAssign from "./KpiTemplateModalAssign";
import KpiTemplateModalCopy from "./KpiTemplateModalCopy";

function KpiTemplateModal({ open, handleClose, showNotification, user, refetchKpiEntries }) {
  const theme = useTheme();
  const isMobileDisplay = useMediaQuery(theme.breakpoints.only("xs"));
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [copying, setCopying] = useState(false);
  const [searchFilter, setSearchFilter] = useState("");
  const [checkboxFilters, setCheckboxFilters] = useState({
    showActive: true,
    showUnassigned: true,
    showAlysio: true,
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobileDisplay ? "90%" : 800,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: isMobileDisplay ? 3 : 4,
    overflowY: "auto",
    borderRadius: "0.5rem",
    outline: "none",
  };

  const handleCloseAction = () => {
    handleClose(dontShowAgain);
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseAction}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {copying ? (
          <KpiTemplateModalCopy
            isMobileDisplay={isMobileDisplay}
            handleClose={handleCloseAction}
            showNotification={showNotification}
            user={user}
            refetchKpiEntries={refetchKpiEntries}
            selectedTemplateId={selectedTemplateId}
            setCopying={setCopying}
          />
        ) : (
          <KpiTemplateModalAssign
            isMobileDisplay={isMobileDisplay}
            handleClose={handleCloseAction}
            dontShowAgain={dontShowAgain}
            setDontShowAgain={setDontShowAgain}
            showNotification={showNotification}
            user={user}
            refetchKpiEntries={refetchKpiEntries}
            selectedTemplateId={selectedTemplateId}
            setSelectedTemplateId={setSelectedTemplateId}
            setCopying={setCopying}
            searchFilter={searchFilter}
            setSearchFilter={setSearchFilter}
            checkboxFilters={checkboxFilters}
            setCheckboxFilters={setCheckboxFilters}
          />
        )}
      </Box>
    </Modal>
  );
}

export default KpiTemplateModal;
